export const OrderByOptions: Array<ICheckbox> = [
  {value: 'lastest', name: 'جدید‌ترین'},
  {value: 'nearest', name: 'نزدیک‌ترین'},
];
